/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from "@azure/msal-browser";

/**
 * Enter here the user flows and custom policies for your B2C application
 * To learn more about user flows, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/user-flow-overview
 * To learn more about custom policies, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/custom-policy-overview
 */
export const b2cPolicies = {
    names: {
        signUpSignIn: 'B2C_1_Novo_Squad_Backoffice',
        // forgotPassword: 'B2C_1_reset_v3',
        editProfile: 'B2C_1_Novo_Squad_Perfil',
    },
    authorities: {
        signUpSignIn: {
            authority: 'https://b2caguiabranca.b2clogin.com/tfp/b2caguiabranca.onmicrosoft.com/B2C_1_Novo_Squad_Backoffice',
        },
        // forgotPassword: {
        //     authority: 'https://fabrikamb2c.b2clogin.com/fabrikamb2c.onmicrosoft.com/B2C_1_reset_v3',
        // },
        editProfile: {
            authority: 'https://b2caguiabranca.b2clogin.com/tfp/b2caguiabranca.onmicrosoft.com/B2C_1_Novo_Squad_Perfil',
        },
    },
    authorityDomain: 'b2caguiabranca.b2clogin.com',
};


/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */
export const msalConfig = {
    auth: {
        clientId: '49a7bd1b-e9f5-473c-92ed-8073d4c455b8', // This is the ONLY mandatory field that you need to supply.
        authority: b2cPolicies.authorities.signUpSignIn.authority, // Choose SUSI as your default authority.
        knownAuthorities: [b2cPolicies.authorityDomain], // Mark your B2C tenant's domain as trusted.
        redirectUri: process.env.REACT_APP_MSAL_REDIRECT_URL, // You must register this URI on Azure Portal/App Registration. Defaults to window.location.origin
        postLogoutRedirectUri: '/', // Indicates the page to navigate after logout.
        navigateToLoginRequestUrl: false, // If "true", will navigate back to the original request location before processing the auth code response.
    },
    cache: {
        cacheLocation: 'sessionStorage', // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        //console.info(message);
                        return;
                    case LogLevel.Verbose:
                        //console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }
            },
        },
    },
};

/**
 * Add here the endpoints and scopes when obtaining an access token for protected web APIs. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const protectedResources = {
    apiCupom: {
        scopes: [
            'https://b2caguiabranca.onmicrosoft.com/d9e7a4ee-29ed-4582-be8e-1d41691cdf69/Full',
        ],
    },
    apiGestao: {
        scopes: [
            'https://b2caguiabranca.onmicrosoft.com/a8910b73-8a63-473f-9318-6700380ac9ff/Full',
        ],
    },
    apiPesquisa: {
        scopes: [
            'https://b2caguiabranca.onmicrosoft.com/d276e3ba-bc12-42c1-9a03-06f4d594ee63/Full',
        ],
    },
    apiVenda: {
        scopes: [
            'https://b2caguiabranca.onmicrosoft.com/189495c7-0be0-46c4-a1d0-dc7d908ed410/Full',
        ],
    },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    scopes: [...protectedResources.apiCupom.scopes],
};